export interface LegislationFileDescriptor {
  id: number;
  title: string;
  fileName: string;
}

export const LEGISLATION_FILES: LegislationFileDescriptor[] = [
  {
    id: 1,
    title: 'Criação dos direitos do COMDICA',
    fileName: 'LEI_N°_827_30_de_junho_de_1994-Criacao_dos_direitos_do_COMDICA.pdf',
  },
  {
    id: 2,
    title: 'Regimento interno',
    fileName: 'DOM2855_REGIMENTO_INTERNO_COMDICA.pdf',
  },
  {
    id: 3,
    title: 'Estatuto da criança e do adolescente',
    fileName: 'ESTATUTO_DA_CRIANCA_E_DO_ADOLESCENTE.PDF',
  },
  {
    id: 4,
    title: 'Lei n° 13.431, de 04 de abril de 2017',
    fileName: 'L13431.pdf',
  },
  {
    id: 5,
    title: 'Decreto n° 9.603, de 10 de dezembro de 2018',
    fileName: 'D9603.pdf',
  },
  {
    id: 6,
    title: 'Resolução n° 235, de 12 de maio de 2013 - CONANDA',
    fileName: 'RESOLUC_A_O_No_235_DE_12_DE_MAIO_DE_2023_18_Maio.pdf',
  },
  {
    id: 7,
    title: 'Lei Ordinaria Municipal n° 2.321, de 27 de setembro de 2022',
    fileName: 'LEI_ORDINARIA_N_2_321.pdf',
  },
  {
    id: 8,
    title: 'Resolução n° 01, de 22 de fevereiro de 2024',
    fileName: 'Resolucao_N_001_2024_Aprovacao_do_Calendario_Reunioes_2024_Aprovado.pdf',
  },
  {
    id: 9,
    title: 'Resolução n° 09, de 2025 - Eleicao de Presidente',
    fileName: 'RESOLUCAO_001_2025_ELEICAO_PRESIDENTE.pdf',
  },
  {
    id: 10,
    title: 'Resolução n° 10, de 2025 - Reprogramação do Saldo',
    fileName: 'RESOLUCAO_002_2025_REPROGRAMACAO_DO_SALDO.pdf',
  },
  {
    id: 11,
    title: 'Resolução n° 11, de 2025 - Calendario das Reunioes',
    fileName: 'RESOLUCAO_003_2025_CALENDARIO_DAS_REUNIOES.pdf',
  },
  {
    id: 12,
    title: 'Resolução n° 12, de 2025 - Comissão Leao Cidadão',
    fileName: 'RESOLUCAO_004_2025_COMISSAO_LEAO_CIDADAO.pdf',
  },
  {
    id: 13,
    title: 'Resolução n° 13, de 2025 - Comissão de Condutas',
    fileName: 'RESOLUCAO_05_COMISSAO_DE_CONDUTAS.pdf',
  },
  {
    id: 14,
    title: 'Resolução n° 14, de 2025 - Comissão de Monitoramento FIA',
    fileName: 'RESOLUCAO_006_2025_COMISSAO_MONITORAMENTO_FIA.pdf',
  },
  {
    id: 15,
    title: 'Resolução n° 15, de 2025 - Convocação das Organizacoes',
    fileName: 'RESOLUCAO_07_2025_CONVOVACAO_DAS_ORGANIZACOES.pdf',
  },
  {
    id: 16,
    title: 'Resolução n° 16, de 2025 - Comissão do Processo Seletivo',
    fileName: 'RESOLUCAO_008_2025_COMISSAO_PROCESSO_SELETIVO.pdf',
  },
  {
    id: 17,
    title: 'Resolução n° 17, de 2025 - Registro Acedonimo',
    fileName: 'RESOLUCAO_009_2025_REGISTRO_ACEDONIMO.pdf',
  },
  {
    id: 18,
    title: 'Resolução n° 18, de 2025 - Comissão Eleitoral do Processo de Escolha COMDICA',
    fileName: 'RESOLUCAO_10_2025_COMISSAO_ELEITORAL_PROCESSO_DE_ESCOLHA_COMDICA.pdf',
  },
  {
    id: 19,
    title: 'Resolução n° 19, de 2025 - Registro das Instituições',
    fileName: 'RESOLUCAO_11_2025_REGISTRO_DAS_INSTITUICOES.pdf',
  },
  {
    id: 20,
    title: 'Resolução n° 20, de 2025 - Composição do COMDICA Bienio 2025-2027',
    fileName: 'RESOLUCAO_12_2025_COMPOSICAO_DO_COMDICA_BIENIO_2025_2027.pdf',
  },
  {
    id: 21,
    title: 'Resolução n° 21, de 2025 - Aprovação da Presidencia',
    fileName: 'RESOLUCAO_013_2025_APROVACAO_PRESIDENCIA.pdf',
  },
  {
    id: 22,
    title: 'Resolução n° 22, de 2025 - Prestação de Contas',
    fileName: 'RESOLUCAO_014_2025_PRESTACAO_DE_CONTAS.pdf',
  },
  {
    id: 23,
    title: 'Resolução n° 23, de 2025 - Comissão do Processo Seletivo (Pedagogo)',
    fileName: 'RESOLUCAO_015_2025_COMISSAO_PROCESSO_SELETIVO_PEDAGOGO.pdf',
  },
  {
    id: 24,
    title: 'Resolução n° 24, de 2025 - Registro do Viva Caju',
    fileName: 'RESOLUCAO_16_2025_REGISTRO_DO_VIVA_CAJU.pdf',
  },
];
